import { ReactComponent as importantMotifs } from "../../assets/images/ic-important-motifs.svg";
import { ReactComponent as similarSequences } from "../../assets/images/ic-similar-sequences.svg";
import { ReactComponent as stabilityScore } from "../../assets/images/ic-stability-score.svg";
import { ReactComponent as collapse } from "../../assets/images/ic-collapse.svg";

interface Props {
  component: any;
  viewBox: string;
}

const svgSet: Record<string, Props> = {
  "important-motifs": {
    component: importantMotifs,
    viewBox: "0 0 60 51",
  },
  "similar-sequences": {
    component: similarSequences,
    viewBox: "0 0 60 51",
  },
  "stability-score": {
    component: stabilityScore,
    viewBox: "0 0 56 40",
  },
  collapse: {
    component: collapse,
    viewBox: "0 0 18 18",
  },
};

export default svgSet;
